import React from 'react';
import { useTranslation } from 'react-i18next';
import { pathManager } from 'routes';

import { Box, Grid } from '@mui/material';

import { RouterButton } from '@libs/ui/components/button';
import Typography from '@libs/ui/components/typography';

import image from './image@2x.png';

interface IntroProps {}

export const Intro = (props: IntroProps) => {
  const { t } = useTranslation('careerHub');

  return (
    <Box>
      <Grid container spacing={{ xs: 4, sm: 6 }} flexDirection="column">
        <Grid item>
          <Typography variant="h4" textAlign="center">
            {t('main.intro.title')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            textAlign="center"
            style={{ maxWidth: 690, margin: '0 auto' }}
          >
            {t('main.intro.body')}
          </Typography>
        </Grid>
        <Grid item container justifyContent="center">
          <RouterButton
            variant="contained"
            color="info"
            to={pathManager.talent.careerHub.pricing.generatePath()}
          >
            {t('main.intro.cta')}
          </RouterButton>
        </Grid>
        <Grid item container justifyContent="center">
          <img
            srcSet={`${image} 2x`}
            alt={t('main.intro.alt')}
            style={{ maxWidth: '100%' }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
